<!-- MAIN View -->

<div
    *ngIf="layout === LAYOUT_MAIN"
    [ngClass]="{
        'app-mobile': layoutService.isMobile(),
        'app-navbar-fixed': app.layout.isNavbarFixed,
        'app-navbar-fixed--with-secondary': layoutService.showSecondaryNav(),
        'app-sidebar-fixed': app.layout.isSidebarFixed,
        'app-sidebar-closed': layoutService.isSidebarClosed,
        'app-offsidebar-open': settings.MessageSidebarOpen,
        'app-footer-fixed': app.layout.isFooterFixed,
        'app-global-header': showGlobalHeader(),
        'app-notifications-header': displayNotificationsPanel && notificationBannerService.notifications.length,
    }"
    id="app"
    class="app-navbar-fixed-v2">
    <!-- <refresher condition="app.lastRefresh"> -->
    <section id="content" class="app-content">
        <div
            class="shuffle-animation main-content"
            [ngClass]="getContentWrapperClasses()"
            [class.with-nav-v2-toggle]="notificationBannerService.notifications.length">
            <div *ngIf="sharedData.Common.ShowUpgradeWarning">
                <div class="alert alert-warning text-center text-large" role="alert">
                    <button type="button" class="close" (click)="hideBrowserWarning()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <i class="ti-alert"></i> <strong>Your browser is not supported.</strong> To get the best experience using Buildxact,
                    please use a modern browser.&nbsp;<a
                        class="button btn btn-warning"
                        target="_blank"
                        href="https://www.google.com/chrome/"
                        >Upgrade to Chrome</a
                    >
                </div>
            </div>
            <app-global-header *ngIf="showGlobalHeader()"></app-global-header>
            <!-- Dev only toggle -->
            <notifications *ngIf="showNotifications()" [columnLayout]="layoutService.getNavV2Layouts()"></notifications>
            <!-- End dev only toggle  -->
            <div
                class="wrap-content container"
                [class.subscription-alert-on]="
                    sharedData.UserData.tenant?.DisplayPaymentIssue &&
                    notificationBannerService.notifications.length > 0 &&
                    displayNotificationsPanel
                ">
                <router-outlet></router-outlet>
            </div>
        </div>
    </section>

    <app-bx-picture-in-picture></app-bx-picture-in-picture>

    <!-- sidebar2 -->

    <app-sidebar2-subpanel
        *ngIf="layoutService.getNavV2Layouts() === 'double' && !layoutService.isMobile()"
        [hidden]="settings.ChatActive"
        class="app-aside sidebar-v2 sidebar-v2--subpanel"
        [ngClass]="{ collapsed: !sidebar2Toggle.open }">
    </app-sidebar2-subpanel>

    <app-sidebar2
        id="sidebar2"
        class="sidebar sidebar-v2 app-aside"
        [ngClass]="{
            'is-mobile': layoutService.isMobile(),
            closed: layoutService.isSidebarClosed,
            'sidebar-collapsed': !layoutService.isMobile() && !sidebar2Toggle?.open,
        }">
    </app-sidebar2>
    <!-- / sidebar2 -->

    <app-nav-bar-mobile *ngIf="showMobileHeader()"></app-nav-bar-mobile>
    <!-- </refresher> -->
</div>

<!-- AUTH View -->
<div *ngIf="layout === LAYOUT_BARE">
    <router-outlet></router-outlet>
</div>
